import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import axios from 'axios';
import Select from 'react-select';
const OrganisationModal = ({
  showModal,
  handleClose,
  orgId,
  orgData,
  addOrg,
  editOrg,
  orgIdError,
  orgs,
  industries,
  type,
  fetchIndustries
}) => {
  const [formData, setFormData] = useState({
    name: '',
    employee_size: '',
    industry_id: '',
    website: '',

    org_type: '',
    address: '',
    country_id: '',
    currency: 'AED',
  });


  const [errors, setErrors] = useState({});
  const [countries, setCountries] = useState([]);

  const fetchCountries = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const origin = localStorage.getItem('user-origin');

      const token = userInfo?.token;

      const response = await axios.get(`${backendUrl}/api/countries`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,

        },
        skipLoader: true,

      });
      // setCountries(response.data.Data);
      const sortedCountries = response.data.Data.sort((a, b) => {
        if (a.name === 'United Arab Emirates') return -1;
        if (b.name === 'United Arab Emirates') return 1;
        return a.name.localeCompare(b.name);
      });

      setCountries(sortedCountries);
      if (!orgData && !formData.country_id) {
        const uae = sortedCountries.find(c => c.name === 'United Arab Emirates');
        if (uae) {
          setFormData(prev => ({
            ...prev,
            country_id: uae.id,
          }));
        }
      }
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  useEffect(() => {
    if (showModal && industries.length === 0) {
      fetchIndustries();
    }
    if (showModal && countries.length === 0) {
      fetchCountries();
    }
    if (showModal && !orgData) {
      // Reset formData for new orgs creation
      setFormData({
        name: '',
        employee_size: '',
        industry_id: '',
        website: '',

        org_type: '',
        address: '',
        country_id: '',
        currency: 'AED',
        short_code: '',
      });
    } else if (orgData) {
      // Populate formData for editing a orgs
      setFormData({
        name: orgData.name || '',
        employee_size: orgData.employee_size || '',
        industry_id: orgData.industry_id || '',
        website: orgData.website || '',

        org_type: orgData.org_type || '',
        address: orgData.address || '',
        country_id: orgData.country_id || '',
        currency: orgData.currency || 'AED',
        short_code: orgData.short_code || '',
      });
    }
  }, [orgData, showModal]);

  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    }
  };

  useEffect(() => {
    if (!showModal) {
      setErrors({});
    }
  }, [showModal]);

  const [currency, setCurrency] = useState('');
  // useEffect(() => {
  //   if (formData.country_id === '231') { // UAE's country_id is 231
  //     setCurrency('AED');
  //     setFormData(prevState => ({
  //       ...prevState,
  //       currency: 'AED',
  //     }));
  //   } else {
  //     setCurrency('USD');
  //     setFormData(prevState => ({
  //       ...prevState,
  //       currency: 'USD',
  //     }));
  //   }
  // }, [formData.country_id]);

  // useEffect(() => {
  //   const selectedCountry = countries.find(
  //     (c) => c.id === formData.country_id
  //   );

  //   if (selectedCountry?.name === 'United Arab Emirates') {
  //     setCurrency('AED');
  //     setFormData(prevState => ({
  //       ...prevState,
  //       currency: 'AED',
  //     }));
  //   } else {
  //     setCurrency('USD');
  //     setFormData(prevState => ({
  //       ...prevState,
  //       currency: 'USD',
  //     }));
  //   }
  // }, [formData.country_id, countries]);

  useEffect(() => {
    if (!countries.length || !formData.country_id) return;

    const selectedCountry = countries.find(c => c.id == formData.country_id);

    if (selectedCountry && selectedCountry.name === 'United Arab Emirates') {
      setCurrency('AED');
      setFormData(prev => ({ ...prev, currency: 'AED' }));
    } else {
      setCurrency('USD');
      setFormData(prev => ({ ...prev, currency: 'USD' }));
    }
  }, [formData.country_id, countries.length]);


  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) {
      newErrors.name = 'Name is required';
    }
    
    if (!formData.country_id) newErrors.country_id = 'Please select a country';

    return newErrors;
  };
  const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return; // Stop here if validation fails
    }
    let apierrors;
    if (orgData) {
      apierrors = await editOrg(orgData.id, formData);
    } else {
      apierrors = await addOrg(formData);
    }

    if (apierrors && Object.keys(apierrors).length > 0) {
      setErrors(apierrors); // Display validation errors
    } else {
      setErrors({}); // Clear errors on success
      handleClose(); // Close modal on success
    }
  };

  return (

    <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '490px' }} backdrop="static">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {orgId ? 'Edit Organisation' : 'Add Organisation'}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr style={{ margin: 0 }} />

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit}>
          {/* Name Field */}
          <Form.Group className="mb-3" controlId="organisationName">
            <Form.Label style={{ fontSize: '13px' }}>Name:</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
              style={{
                fontSize: '14px',
                // maxWidth: '320px',
                borderRadius: '14px',
                height: '39px',
                border: '0.5px solid rgb(232, 233, 237)'
              }}
            />
            {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}

          </Form.Group>
          <Form.Group className="mb-3" controlId="organisationShortCode">
            <Form.Label style={{ fontSize: '13px' }}>Short Code:</Form.Label>
            <Form.Control
              type="text"
              name="short_code"
              value={formData.short_code}
              onChange={handleChange}
              className='form-control'
              style={{
                fontSize: '14px',
                // maxWidth: '320px',
                borderRadius: '14px',
                height: '39px',
                border: '0.5px solid rgb(232, 233, 237)'
              }}
            />

          </Form.Group>

          {/* Employee Size Field */}
          <Form.Group className="mb-3" controlId="employeeSize">
            <Form.Label style={{ fontSize: '13px' }}>Employee Size:</Form.Label>
            <Form.Control
              type="text"
              name="employee_size"
              value={formData.employee_size}
              onChange={handleChange}
              style={{
                fontSize: '14px',
                // maxWidth: '320px',
                borderRadius: '14px',
                height: '39px',
                border: '0.5px solid rgb(232, 233, 237)'
              }}
            />
          </Form.Group>

          {/* Industry (Sector) Field */}
          <Form.Group className="mb-3" controlId="industryId">
            <Form.Label style={{ fontSize: '13px' }}>Sector:</Form.Label>
            <Form.Select
              name="industry_id"
              value={formData.industry_id}
              onChange={handleChange}
              style={{
                fontSize: '14px',
                borderRadius: '14px',
                height: '39px',
                border: '0.5px solid rgb(232, 233, 237)'
              }}
            >
              <option value="">Select</option>
              {industries?.filter(industry => industry.id)
                .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                .map((industry) => (
                <option key={industry.id} value={industry.id}>
                  {industry.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Website Field */}
          <Form.Group className="mb-3" controlId="website">
            <Form.Label style={{ fontSize: '13px' }}>Website:</Form.Label>
            <Form.Control
              type="text"
              name="website"
              value={formData.website}
              onChange={handleChange}
              style={{
                fontSize: '14px',
                borderRadius: '14px',
                height: '39px',
                border: '0.5px solid rgb(232, 233, 237)'
              }}
            />
          </Form.Group>

          {/* Organisation Type Field */}
          <Form.Group className="mb-3" controlId="orgType">
            <Form.Label style={{ fontSize: '13px' }}>Type:</Form.Label>
            <Form.Select
              name="org_type"
              value={formData.org_type}
              onChange={handleChange}
              style={{
                fontSize: '14px',
                borderRadius: '14px',
                height: '39px',
                border: '0.5px solid rgb(232, 233, 237)'
              }}
            >
              <option value="">Select Type</option>
              <option value="end customer">End Customer</option>
              <option value="partner">Partner</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="country">
            <Form.Label style={{ fontSize: '13px' }}>Country:</Form.Label>
            <Select
              name="country_id"
              options={countries.map(c => ({ value: c.id, label: c.name }))}
              value={countries.map(c => ({ value: c.id, label: c.name })).find(opt => opt.value == formData.country_id) || null}
              onChange={(selectedOption) => {
                setFormData(prev => ({ ...prev, country_id: selectedOption ? selectedOption.value : '' }));
                if (errors.country_id) {
                  setErrors(prev => ({ ...prev, country_id: undefined }));
                }
              }}
              isClearable
              isSearchable
              className={errors?.country_id ? 'is-invalid' : ''}
              styles={{
                control: (base) => ({
                  ...base,
                  fontSize: '14px',
                  borderRadius: '14px',
                  minHeight: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                })
              }}
            />
            {errors.country_id && <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>*{errors.country_id}</div>}
          </Form.Group>

          {/* Address Field */}
          <Form.Group className="mb-3" controlId="address">
            <Form.Label style={{ fontSize: '13px' }}>Address:</Form.Label>
            <Form.Control
              as="textarea"
              name="address"
              value={formData.address}
              onChange={handleChange}
              style={{
                fontSize: '14px',
                // maxWidth: '320px',
                borderRadius: '14px',
                height: '39px',
                border: '0.5px solid rgb(232, 233, 237)'
              }}
            />
          </Form.Group><br />

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </Offcanvas.Body >
    </Offcanvas >
  );
};

export default OrganisationModal;
